<!--====== Banar Start Here ======-->
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center  w-100">
                <img src="../../../assets/images/banners/technology_trainingbgimage.png"
                    alt="technology training banner" class="img img-responsive w-100 h-100 d-none d-md-block">
                <img src="../../../assets/images/banners/technologytraining_mobilebannar.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="technology training mobile bannar" />

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-md-4 col-sm-12">
                            <div class=" banner-section">
                                <div class="align-items-center global_title global_banner_title" role="heading" aria-level="1">
                                    <span>Technology Training</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                    <span>We offer unique learning experiences for the next generation by our
                                        professionals.</span>
                                </div>
                                <div class="col pt-lg-4 pt-4">
                                    <a href="/internship"
                                        class="global_button  text-left col pt-lg-3 text-white white_button" aria-label="View Internship Page" role="button" tabindex="0">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                                alt="explore opportunities" /></div>
                                        EXPLORE OPPORTUNITIES
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== Banar End Here ======-->
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="blog-pages-wrapper section-space--ptb_90">
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-8">
                    <div class="vision-content-section section-title-wrap text-center section-space--mb_60">
                        <p>SPARKMINDS is a program conducted by Maganti IT Resources, through which young minds are
                            trained and sculpted. Internships are provided to students to shape their career. We
                            give immersive learning across entire software cycle to freshers and provide placements
                            according to their interest and skillset.</p>
                    </div>
                </div>
                <div class="col-lg-2"></div>
            </div>
            <div class="main-blog-wrap">
                <!--====== Internship Start  ======-->
                <div class="single-blog-item post-list-wrapper xs-list-blog-item border-bottom wow move-up">
                    <div class="row ">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5">
                            <div class="post-feature blog-thumbnail">
                                <img src="../../../assets/images/techtraining_images/trainingimage1.png"
                                    class="trainingintern_subimage w-100 h-100" title="techtraining-internship"
                                    alt="sparkminds internship">
                            </div>
                        </div>
                        <div class="col-lg-5 mt-3 mt-md-3 mt-lg-0">
                            <div class="post-info lg-blog-post-info">
                                <div class="fourthheading post-title" role="heading">
                                    <div>INTERNSHIP</div>
                                </div>
                                <div class=" global_section_content post-excerpt mt-15">
                                    <p>Explore internships that are springboards for your dynamic career. We're always
                                        on the lookout for passionate individuals who're willing to expand their
                                        horizons of capabilities. Are you seeking to be part of a growing organization?
                                        We'd love to join you.
                                    </p>
                                </div>
                                <div class="mt-5">
                                    <a href="/internship" class="global_button explore text-left col " aria-label="View Internship Page" role="button" tabindex="0">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png"
                                                alt="explore more opportunities" /></div>
                                        EXPLORE OPPORTUNITIES
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!--====== Internship End  ======-->
                <!--====== Meetup Start  ======-->
                <div class="single-blog-item post-list-wrapper xs-list-blog-item border-bottom wow move-up">
                    <div class="row ">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5">
                            <div class="post-info lg-blog-post-info">
                                <div class="fourthheading post-title" role="heading" aria-level="1">
                                    <div>MEETUP</div>
                                </div>
                                <div class="global_section_content post-excerpt mt-15">
                                    <p>
                                        Meet people who have expertise in their respective fields and grasp knowledge
                                        from them. Indulge in sessions with like-minded individuals seeking careers in
                                        the same platform. Leverage the experience to cultivate a growth mindset and get
                                        ahead in the learning curve.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="post-feature blog-thumbnail">
                                <img src="../../../assets/images/techtraining_images/trainingimage2.png"
                                    class="trainingintern_subimage w-100 h-100" alt="sparkminds events">
                            </div>
                        </div>
                    </div>
                </div>
                <!--====== Meetup End  ======-->
                <!--====== TRAININGS Start  ======-->
                <div class="single-blog-item post-list-wrapper xs-list-blog-item border-bottom wow move-up">
                    <div class="row ">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5  ">
                            <div class="post-feature blog-thumbnail">
                                <img src="../../../assets/images/techtraining_images/trainingimage3.png"
                                    class="trainingintern_subimage w-100 h-100" alt="sparkminds trainings">
                            </div>
                        </div>
                        <div class="col-lg-5 mt-3 mt-md-3 mt-lg-0">
                            <div class="post-info lg-blog-post-info">
                                <div class="fourthheading post-title" role="heading" aria-level="1">
                                    <div>TRAININGS</div>
                                </div>
                                <div class="global_section_content post-excerpt mt-15">
                                    <p> Identify your passion and build a career path by Learning from the senior
                                        resources on projects. Engage in Real-time client projects- Daily scrum calls,
                                        client meeting involvements once the training is completed. Gain hands-on
                                        experience in fast-growing industry verticals and build confidence to start your
                                        career.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>